<template>
  <div>
    <div v-if="globalcontacthistory && globalcontacthistory.length">
      <md-list class="md-double-line contactlist">
        <div v-for="(contact,index) in globalcontacthistory" :key="contact.contactnumber">
          <md-list-item v-on:click="selectContact(contact.contactnumber)" v-bind:class="{ activecontact: (contact.contactnumber === selectedcontactSMS)}">
            <div class="md-list-item-text">
              <span class="name">
                <md-field>
                  <!-- <label>Name</label> -->
                  <md-input v-model="globalcontacthistory[index].name"
                    @keyup.enter="saveName(globalcontacthistory[index].name,globalcontacthistory[index].contactnumber)"
                    placeholder="(click to edit name)">
                     <!-- :disabled="disabled" @click="disabled = !disabled"> -->
                     <!-- <md-badge class="md-primary md-square" md-content="6" /> -->
                  </md-input>
                </md-field>
              </span>
              <span class="smaller">{{ contact.contactnumber }}</span>
              <span class="smaller">{{ contact.dateSent | readableTime }}</span>
              <md-tooltip>(click to edit)</md-tooltip>
              <!-- <md-icon class="md-fab md-fab-bottom-right md-mini" @click="{{ contact.contactnumber }}active = true">edit</md-icon> -->
              <!-- <md-dialog-prompt
                :md-active.sync="{{ contact.contactnumber }}active"
                v-model="contact.contactnumber"
                md-title="Edit the name of this contact"
                md-input-maxlength="30"
                md-input-placeholder="Contact Name"
                md-confirm-text="Done" /> -->
            </div>
          </md-list-item>
          <md-divider></md-divider>
        </div>
      </md-list>
      <NewMessage/>
      <!-- <md-button class="md-fab md-mini md-fab-bottom-left" v-on:click="$store.dispatch('getCallerIDnames')">
        <md-icon>refresh</md-icon>
        <md-tooltip md-direction="top">Refresh Conversation List</md-tooltip>
      </md-button> -->
    </div>
    <div v-else>
      <md-empty-state
        md-icon="people"
        md-label="Loading..."
        md-description="Loading Contacts...">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </md-empty-state>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import db from '../services/firebase'
// import axios from 'axios'
import { mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import NewMessage from '@/components/NewMessage'

// var updateContactNamesDebounced = _.debounce(function (mythis) { // YES, this will always be debounced
//   mythis.$store.state.globalcontacthistorywithnames = mythis.$store.state.globalcontacthistory
// }, 1000)

export default {
  components: {
    NewMessage
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'userfirstname',
      'userlastname',
      'useremail',
      'usercolor',
      'userlevel',
      'userTwilioAccountSID',
      'teamTwilioAccountSID',
      'teamTwilioAuthToken',
      'teamTwilioSMSNumber',
      'teamname',
      'forceConversationUpdate'
    ]),
    ...mapFields([
      'selectedcontactSMS',
      'teamlastupdate',
      'globalcontacthistory'
    ])
  },
  mounted () {
    console.log('Mounted ActiveConversation')
    console.log(this.teamTwilioSMSNumber)
    // setTimeout(this.updateContactNames(), 25000)
  },
  updated () {
    // this.updateContactNames()
  },
  methods: {
    updateContactNames () {
      console.log('Updating contact names...')
      var self = this
      db.collection('teams')
        .doc(this.$store.state.teamTwilioAccountSID)
        .collection('contacts')
        .get()
        .then(function (querySnapshot) {
          console.log('updateContactNames - then')
          console.log(self.$store.state.globalcontacthistory)
          querySnapshot.forEach(function (doc) {
            for (var i = 0; i < self.$store.state.globalcontacthistory.length; i++) {
              if (self.$store.state.globalcontacthistory[i]['contactnumber'] === doc.id) {
                self.$store.state.globalcontacthistory[i].name = doc.data().name
              }
            }
          })
        })
    },
    selectContact (contactnumber) {
      console.log('Switching to: ' + contactnumber)
      this.selectedcontactSMS = contactnumber
      db.collection('teams')
        .doc(this.teamTwilioAccountSID)
        .collection('contacts')
        .doc(contactnumber)
        .update({
          lastviewed: Math.floor(Date.now() / 1000)
        })
    },
    saveName (contactname, contactnumber) {
      console.log(contactname + ' -- ' + contactnumber)
      console.log(this.teamTwilioAccountSID)
      db.collection('teams')
        .doc(this.teamTwilioAccountSID)
        .collection('contacts')
        .doc(contactnumber)
        .update({
          name: contactname
        }).then(() => {
          console.log('Updated Name')
        }).catch((error) => {
          console.log(error)
          db.collection('teams')
            .doc(this.teamTwilioAccountSID)
            .collection('contacts')
            .doc(contactnumber)
            .set({
              name: contactname
            })
        })
    }
  },
  watch: {
    teamlastupdate: function (newdata, olddata) {
      if (!newdata === olddata) {
        this.$store.dispatch('getContactHistory')
      }
    },
    globalcontacthistory: function (newdata, olddata) {
      this.$store.dispatch('getCallerIDnames')
      setTimeout(this.updateContactNames(), 500)
    }
  }
}
</script>

<style scoped>
  .is-active {
    background-color: #999999;
  }

  .contactlist {
    overflow-y: scroll;
    max-height: 100vh - 154px;
  }

  .activecontact {
    background-color: #aaaaaa;
  }

  .smaller {
    font-size: .8em;
    display: inline-flex;
  }

  .name {
    font-size: 1.1em;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/ActiveConversations.vue